import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Hero = ({ todaysWhiskey }) => {


    const date = new Date(todaysWhiskey.date.seconds * 1000).getDate()
    const month = new Date(todaysWhiskey.date.seconds * 1000).getMonth() + 1

    const navigate = useNavigate()
    return (
        <div className="relative isolate py-24 sm:py-32 overflow-x-clip md:overflow-x-visible" >

           {todaysWhiskey.subName === "Yeun Elez" ? <img
                alt=""
                src={todaysWhiskey.image}
                className="absolute  md:right-14 grayscale opacity-20 lg:right-40 xl:right-72 sm:-right-8 -right-16 top-10 -z-10 w-80 object-cover object-right md:object-center mask-none animate__animated animate__slideInRight"
            /> : <img
                alt=""
                src={todaysWhiskey.image}
                className="absolute  md:right-14 grayscale opacity-20 lg:right-40 xl:right-72 sm:-right-8 -right-16 top-10 -z-10 w-40 object-cover object-right md:object-center mask-none animate__animated animate__slideInRight"
            />} 
            {/* <div
                aria-hidden="true"
                className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
            >
                <div
                    style={{
                        clipPath:
                            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                    }}
                    className="aspect-1097/845 w-274.25 bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                />
            </div> */}
            {/* <div
                aria-hidden="true"
                className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:-top-112 sm:ml-16 sm:translate-x-0"
            >
                <div
                    style={{
                        clipPath:
                            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                    }}
                    className="aspect-1097/845 w-274.25 bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                />
            </div> */}
            <div className="mx-auto max-w-7xl px-6 lg:px-8 animate__animated animate__slideInLeft">
                <div className="mx-auto max-w-2xl lg:mx-0">
                    <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-white">Whiskeykalendern 2025</h2>
                    <p className="mt-8 text-3xl font-medium text-pretty text-gray-300">{todaysWhiskey.name}
                    </p>
                        {month !== 12 && <img className='w-80' src={todaysWhiskey.logo} />}

                    <p className="mt-4 w-92 text-xl font-medium text-pretty text-gray-500">{todaysWhiskey.subName}
                    </p>
                    <div className="mt-8">
                        {todaysWhiskey.id !== 1 && <a href={`whiskey/${todaysWhiskey.id}`} className="rounded-md bg-gray-700 px-3.5 py-2.5 text-sm font-semibold text-white inset-ring inset-ring-white/5 hover:bg-gray-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"> Läs mer </a>}
                        {/* <a href={`whiskey/${todaysWhiskey.id}`} className="rounded-md bg-gray-700 px-3.5 py-2.5 text-sm font-semibold text-white inset-ring inset-ring-white/5 hover:bg-gray-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"> Läs mer </a> */}
                    </div>

                </div>
                <div className="mx-auto mt-10 max-w-2xl lg:mx-0 lg:max-w-none">
                    {/* <div className="grid grid-cols-1 gap-x-8 gap-y-6 text-base/7 font-semibold text-white sm:grid-cols-2 md:flex lg:gap-x-10">
            {links.map((link) => (
              <a key={link.name} href={link.href}>
                {link.name} <span aria-hidden="true">&rarr;</span>
              </a>
            ))}
          </div> */}
                    <dl className="mt-16 grid grid-cols-1 gap-8 sm:mt-20 sm:grid-cols-2 lg:grid-cols-4">
                        {/* {stats.map((stat) => (
              <div key={stat.name} className="flex flex-col-reverse gap-1">
                <dt className="text-base/7 text-gray-300">{stat.name}</dt>
                <dd className="text-4xl font-semibold tracking-tight text-white">{stat.value}</dd>
              </div>
            ))} */}
                    </dl>
                </div>
            </div>
        </div >
    )
}

export default Hero